import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexAos',
  setup(__props) {

const aosExample = defineAsyncComponent(() => import("@/components/theme/animation/aos/aosExample.vue"))
const initAOS = defineAsyncComponent(() => import("@/components/theme/animation/aos/initAOS.vue"))
const animationView = defineAsyncComponent(() => import("@/components/theme/animation/aos/animationView.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Animation",
      title: "AOS Animation"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(aosExample)),
        _createVNode(_unref(initAOS)),
        _createVNode(_unref(animationView))
      ])
    ])
  ], 64))
}
}

})